// extracted by mini-css-extract-plugin
module.exports = {"language":"layout_language__M397J","body":"layout_body__bh9m1"};